export default "__VITE_ASSET__C_j1hPnf__"